// @ts-nocheck
/** @param {ShadowRoot} shadow */
const applyPatches = (shadow) => {
  const dialog = shadow.querySelector('[data-sizing="form-wrapper"][role="dialog"]');
  if (dialog) {
    const lbl = dialog.getAttribute('aria-label');
    if (!lbl || lbl.trim() === '') {
      const heading = document.querySelector('h1, h2, h3');
      const name = (heading && heading.textContent.trim()) || (document.title.split(/[–—-]/)[0] ?? document.title).trim();
      dialog.setAttribute('aria-label', name);
    }
  }

  shadow.querySelectorAll('textarea').forEach((ta) => {
    if (ta.getAttribute('aria-label') || ta.getAttribute('aria-labelledby')) return;
    const wrapper = ta.closest('[class*="_formFieldContainer_"]');
    const lbl = wrapper && wrapper.querySelector('label');
    if (lbl) {
      if (!ta.id) ta.id = `sc-ta-${Math.random().toString(36).slice(2, 7)}`;
      lbl.setAttribute('for', ta.id);
    } else {
      const fieldName = (ta.getAttribute('name') || '').replace(/^custom#/, '').replace(/_/g, ' ');
      ta.setAttribute('aria-label', fieldName || 'Additional comments');
    }
  });

  shadow.querySelectorAll('button[aria-controls*="-selector-dropdown"]').forEach((btn) => {
    if (btn.getAttribute('aria-label') || btn.getAttribute('aria-labelledby')) return;
    const container = btn.closest('[class*="_selectContainer_"]');
    const formField = container && container.closest('[class*="_formFieldContainer_"], [class*="_gridItem_"]');
    const lbl = formField && formField.querySelector('label');
    if (lbl) {
      btn.setAttribute('aria-label', lbl.textContent.trim());
    } else {
      const controls = btn.getAttribute('aria-controls') || '';
      const fieldName = controls.replace(/^custom#/, '').replace(/-selector-dropdown$/, '').replace(/_/g, ' ');
      btn.setAttribute('aria-label', fieldName || 'Select option');
    }
  });

  if (!shadow.querySelector('#sc-a11y-contrast')) {
    const style = document.createElement('style');
    style.id = 'sc-a11y-contrast';
    style.textContent = `
      label, [class*="_formInputFieldLabel_"] { color: #595959 !important; }
      [class*="_inputFilled_"] { color: #595959 !important; }
      @media (max-width: 768px) {
        [class*="_horizontalLayout_"] {
          flex-direction: column !important;
          gap: 8px !important;
        }
        form[class^="_formFieldset"] input,
        form[class^="_formFieldset"] textarea,
        form[class^="_formFieldset"] label {
          font-size: 14px !important;
        }

        form[class^="_formFieldset"] input:focus + label,
        form[class^="_formFieldset"] textarea:focus + label {
           font-size: 12px !important;
           line-height: 1 !important;
        }

        div[class*="_horizontalLayout_"] {
        display: flex !important;
         flex-direction: column !important;
         gap: 8px !important;
         }
      }
      [class*="_inline_"] { justify-items: stretch !important; }
      [class*="_container_3eyaa"] { justify-content: stretch !important; }
    `;
    shadow.appendChild(style);
  }
};

/** @param {ShadowRoot} shadow */
const watchShadow = (shadow) => {
  applyPatches(shadow);
  const observer = new MutationObserver(() => applyPatches(shadow));
  observer.observe(shadow, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label'] });
};

/** @param {Element} host */
const attachToHost = (host) => {
  if (!host.shadowRoot) {
    const upgradeTimer = setInterval(() => {
      if (host.shadowRoot) {
        clearInterval(upgradeTimer);
        watchShadow(host.shadowRoot);
      }
    }, 50);
    return;
  }
  watchShadow(host.shadowRoot);
};

const init = () => {
  const host = document.querySelector('shopify-forms-embed');
  if (host) {
    attachToHost(host);
    return;
  }

  const bodyObserver = new MutationObserver((_, obs) => {
    const h = document.querySelector('shopify-forms-embed');
    if (h) {
      obs.disconnect();
      attachToHost(h);
    }
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
